export enum SendPaymentTypeEnum {
    SendPaymentDashboard = 1,
    SendPaymentFromTrade = 2
}
